import { Box, Button, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const NoPage = () => {
    const theme = useTheme();
    const { t } = useTranslation("translation", { keyPrefix: "noPage" });
    const navigate = useNavigate();

    return (
        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
            <Typography variant="h1" sx={{ fontWeight: 700, color: theme.palette.text.primary, mb: 2 }}>
                404
            </Typography>
            <Typography variant="h2" sx={{ color: theme.palette.text.primary, mb: 0.5 }}>
                {t("pageNotFound")}
            </Typography>
            <Typography sx={{ color: theme.palette.text.primary }}>Az oldal amit keresel nem létezik vagy át lett helyezve.</Typography>
            <Button
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primaryButtonIcon,
                    textTransform: "none",
                    mt: 1,
                    paddingInline: 1.5,
                    paddingBlock: 1,
                    borderRadius: 1.5,
                    "&:hover": {
                        scale: 1.02,
                        backgroundColor: theme.palette.primary.dark
                    }
                }}
                onClick={() => navigate("/")}
            >
                {t("backToMainPage")}
            </Button>
        </Box>
    );
};

export default NoPage;
